import type { SanitizedQuestionItem } from "../../../shared/types";
import { VisualQuestionRenderer } from "./VisualQuestionRenderer";

export function QuestionCard({
  question,
  selectedOption,
  onSelect
}: {
  question: SanitizedQuestionItem;
  selectedOption?: string | null;
  onSelect?: (optionId: string) => void;
}) {
  return (
    <section className="glass-panel mt-3 rounded-lg p-4 sm:p-5" aria-labelledby="question-title">
      <h1 id="question-title" className="text-xl font-semibold leading-8 text-white sm:text-2xl">
        {question.prompt}
      </h1>
      <div className="mt-4 flex justify-center">
        <VisualQuestionRenderer question={question} selectedOption={selectedOption} onSelect={onSelect} />
      </div>
    </section>
  );
}
